<!-- Modal Overlay -->
@if (isModalOpen()) {
  <div
    class="fixed inset-0 bg-gray-950/30 flex items-center justify-center z-50 animate-in fade-in duration-300"
    (click)="closeModal()">
    <!-- Modal Content -->
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6 animate-in zoom-in-95 duration-300"
      (click)="$event.stopPropagation()">
      <!-- Modal Header -->
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold text-gray-800">Seleccionar tipo de devolución</h2>
        <button (click)="closeModal()"
          class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      <!-- Refund Options -->
      <div class="space-y-4 mb-6">
        <!-- Subicoins Option -->
        <label class="flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200"
          [class]="selectedRefundMethod() === 'subicoins' ? 'border-amber-500 bg-amber-50' : 'border-gray-200 hover:border-gray-300'">
          <div class="relative">
            <input type="radio"
              name="refundMethod"
              value="subicoins"
              class="appearance-none w-5 h-5 border-2 border-gray-300 rounded-full cursor-pointer transition-all duration-200 checked:border-amber-500 checked:bg-amber-50"
              [checked]="selectedRefundMethod() === 'subicoins'"
              (change)="selectRefundMethod('subicoins')">
            @if (selectedRefundMethod() === 'subicoins') {
              <div
                class="absolute inset-0 flex items-center justify-center">
                <div class="w-3 h-3 bg-amber-500 rounded-full"></div>
              </div>
            }
          </div>
          <div class="ml-3 flex-1">
            <div class="flex items-center">
              <div class="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center mr-3">
                <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z"></path>
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clip-rule="evenodd"></path>
                </svg>
              </div>
              <div>
                <h3 class="font-medium text-gray-900">Créditos</h3>
                <p class="text-sm text-gray-500">Recibe el reembolso en créditos Subicoins</p>
              </div>
            </div>
          </div>
        </label>
        <!-- Card Option -->
        <label class="flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200"
          [class]="selectedRefundMethod() === 'card' ? 'border-amber-500 bg-amber-50' : 'border-gray-200 hover:border-gray-300'">
          <div class="relative">
            <input type="radio"
              name="refundMethod"
              value="card"
              class="appearance-none w-5 h-5 border-2 border-gray-300 rounded-full cursor-pointer transition-all duration-200 checked:border-amber-500 checked:bg-amber-50"
              [checked]="selectedRefundMethod() === 'card'"
              (change)="selectRefundMethod('card')">
            @if (selectedRefundMethod() === 'card') {
              <div
                class="absolute inset-0 flex items-center justify-center">
                <div class="w-3 h-3 bg-amber-500 rounded-full"></div>
              </div>
            }
          </div>
          <div class="ml-3 flex-1">
            <div class="flex items-center">
              <div class="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center mr-3">
                <svg class="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"></path>
                  <path fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clip-rule="evenodd"></path>
                </svg>
              </div>
              <div>
                <h3 class="font-medium text-gray-900">Tarjeta</h3>
                <p class="text-sm text-gray-500">Reembolso directo a tu tarjeta de pago</p>
              </div>
            </div>
          </div>
        </label>
      </div>
      <!-- Action Buttons -->
      <div class="flex space-x-3">
        <button (click)="closeModal()"
          class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors">
          Cancelar
        </button>
        <button (click)="submitDevolucion()"
          [disabled]="!selectedRefundMethod()"
          class="flex-1 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors">
          Confirmar
        </button>
      </div>
    </div>
  </div>
}
